// extracted by mini-css-extract-plugin
export default {"favActive":"favActive--hzHoo","description":"description--QUd5p"};